module.exports = __webpack_public_path__ + "assets/zalo1.565ee1c6.svg";